/* eslint-disable no-mixed-operators */

import React, { useState, useEffect } from 'react';

import { MembershipCardWide, MEMBERSHIP_TIERS } from './MembershipCard';

export default function RevolvingMembershipCard({ name, cardId }) {
    const [ tierIdx, setTierIdx ] = useState(0);

    useEffect(() => {
        const t = setInterval(() => {
            setTierIdx(currentTierIdx => {
                return currentTierIdx + 1 < MEMBERSHIP_TIERS.length ? currentTierIdx + 1 : 0;
            });
        }, 5000);

        return () => {
            clearInterval(t);
        }
    }, [setTierIdx]);

    return (
        <>
            <MembershipCardWide
                name={name}
                cardId={cardId}
                tierCode={MEMBERSHIP_TIERS[tierIdx]}
            />
            <div style={{ display: 'none' }}>
                {
                    // To get images to pre-load...
                    MEMBERSHIP_TIERS.map(tier => (
                        <MembershipCardWide
                            key={tier}
                            name='Member'
                            cardId='00000000'
                            tierCode={tier}
                        />
                    ))
                }
            </div>
        </>
    );
}
